import React, { useEffect } from 'react'
import { useDataValue, useDataChange } from 'Simple/Data'
import View from './view.js'

export default function Logic(props) {
  let enableEditor = useDataChange({
    context: 'expand',
    path: 'email_editor_enabled',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    enableEditor(true)
  }, [])

  return <View {...props} />
}
